import { ApiPaginatedResponse } from '@config/api';
import { Nullable } from '@utils/util.types';
import { create } from 'zustand';

interface FarmState {
	farmId: Nullable<string>;
	singleFarm: Nullable<any>;
	farms: Nullable<ApiPaginatedResponse<any>>;
	setFarms: (farms: ApiPaginatedResponse<any>) => void;
	setSingleFarm: (farm: any) => void;
}

export const useFarmStore = create<FarmState>((set) => ({
	farmId: null,
	singleFarm: null,
	farms: null,
	setFarms: (farms: ApiPaginatedResponse<any>) => set({ farms }),
	setSingleFarm: (farm) => {
		return set({ singleFarm: farm });
	},
}));
